module.exports = __webpack_public_path__ + "static/img/banner_partner.570b674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_partner.jpg
// module id = amTg
// module chunks = 2